import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { styles } from './styles';

interface KeyStatItemProps {
  name: string;
  value: string;
}

export const KeyStatItem: FC<KeyStatItemProps> = ({ name, value }) => {
  return (
    <Box sx={{ ...styles.wrap }}>
      <Typography sx={{ ...styles.title }}>{name}</Typography>
      <Typography sx={{ ...styles.value }}>{value}</Typography>
    </Box>
  );
};
